import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaGithub, FaLink } from "react-icons/fa";

export default function Projects({ projects }) {
  var settings = {
        lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section id="projects">
      <h1
        className="projects__title"
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
      >
        Projects
      </h1>
      <p
        className="projects__intro"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-anchor-placement="center-bottom"
      >
        Selected work tied to business operations, ecommerce, analytics, and
        content systems.
      </p>
      <ul className="projects__list">
        {projects.map((project) => (
          <li
            className="project"
            key={project.id}
            data-aos="slide-up"
            data-aos-anchor-placement="bottom-bottom"
          >
            <div className="project__details">
              <h2 className="project__title white">{project.projectTitle}</h2>
              {project.outcome && (
                <p className="project__outcome">{project.outcome}</p>
              )}
              {project.businessProof && (
                <div className="project__business-proof">
                  <div className="project__business-item">
                    <span className="project__business-label">Built for</span>
                    <strong>{project.businessProof.builtFor}</strong>
                  </div>
                  <div className="project__business-item">
                    <span className="project__business-label">
                      Business value
                    </span>
                    <strong>{project.businessProof.value}</strong>
                  </div>
                </div>
              )}
            </div>

            <div className="project__visuals">
              <Slider {...settings}>
                {project.images.map((image, index) => (
                  <figure className="project__carousel" key={index}>
                    {image.video ? (
                      <video
                        src={image.video}
                        className="project__images project__video"
                        controls
                        preload="metadata"
                        aria-label={image.label}
                      />
                    ) : (
                      <img
                        src={image[`image${index + 1}`]}
                        alt={`Project screenshot ${index + 1}`}
                        className="project__images"
                      />
                    )}
                  </figure>
                ))}
              </Slider>

              <div className="project__links">
                {project.webLink && (
                  <a
                    href={project.webLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project__link"
                  >
                    <FaLink color="white" size={21} />
                  </a>
                )}

                {project.githubLink && (
                  <a
                    href={project.githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project__link"
                  >
                    <FaGithub color="white" size={21} />
                  </a>
                )}
              </div>
            </div>
            <div className="project__support">
              <details className="project__detail-panel">
                <summary>Project context</summary>
                <p className="project__desc white">{project.description}</p>
              </details>

              <details className="project__detail-panel">
                <summary>Service fit and stack</summary>
                <div className="project__meta">
                  {project.serviceProof && (
                    <div className="project__meta-row">
                      <span className="project__meta-label">Service fit</span>
                      <ul
                        className="project__proof-list"
                        aria-label="Service proof"
                      >
                        {project.serviceProof.map((proof) => (
                          <li className="project__proof" key={proof}>
                            {proof}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <p className="project__tech white">
                    <span className="project__meta-label">Stack</span>
                    {project.tech}
                  </p>
                </div>
              </details>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
